import { sendGet } from './request-utils';

const API_PATH = 'cms-resource/public/v1/resource/';

export default class ResourceApi {
  static getLangtexts(application: string) {
    return sendGet(API_PATH + 'LANGTEXT/' + application, null);
  }
}
